import RenderFormItem from './render-form-item'
import mixinEnableWhen from './mixin-enable-when'

export default {
  name: 'VsFormGroupBuilder',
  components: {
    'render-form-item': RenderFormItem
  },
  mixins: [mixinEnableWhen],
  props: {
    data: {
      type: Object,
      default: null
    },
    itemValue: {},
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    }
  },
  render(h) {
    if (!this._show) return

    const groupItems = this.data.$items.map((item, index) => {
      const itemValue = this.itemValue || {}
      const itemOptions = {
        props: {
          key: index,
          prop: `${this.data.$id}.${item.$id}`,
          data: item,
          value: this.value,
          itemValue: itemValue[item.$id],
          disabled: this.disabled
        },
        on: {
          updateValue: ({ id, value }) => {
            let val = Object.assign({}, itemValue, { [id]: value })

            this.$emit('updateValue', {
              id: this.data.$id,
              value: val
            })
          }
        }
      }

      return h('render-form-item', itemOptions)
    })

    const columns = this.$vessel.coerce(this.data.$columns, val => val || 2)
    const colSpan = (this.data.$attrs || {}).span || 2
    const classes = this.$vessel.apply({
      display: 'grid',
      gridColumns: columns,
      gridColumnSpan: colSpan,
      gridGap: 'sm',
      margin: 0
    })

    const component = this.data.$component
    const groupComp = h('div', { class: classes }, [groupItems])

    if (component) {
      const columns = this.$vessel.apply({ gridColumnSpan: colSpan })
      return h(component, { props: this.data.$el, class: columns }, [groupComp])
    } else {
      return groupComp
    }
  }
}
